import { Component, OnInit } from '@angular/core';
import {ICellRendererAngularComp} from "ag-grid-angular";
import {LoginService} from '../login.service';
import { ToastrService } from 'ngx-toastr';
import { Router,RouterModule} from '@angular/router';

@Component({
  selector: 'app-acknowledge',
  templateUrl: './acknowledge.component.html',
  styleUrls: ['./acknowledge.component.css']
})
export class AcknowledgeComponent implements ICellRendererAngularComp  {
  
    public params: any;
    public gridApi:any;
    gridColumnApi:any;
    constructor(public loginService:LoginService, public toastService:ToastrService, public router: Router) { }
   
        agInit(params: any): void {
            this.params = params;
            this.gridApi = params.api;
            this.gridColumnApi = params.columnApi;
        }
    
        refresh(): boolean {
            return false;
        }
        update(){
            var selectedData = this.gridApi.getSelectedRows();
            let arr =[];
            arr.push(this.params.data);
            let request = {
                id:[]
            };
            request.id.push(this.params.data.id)
            this.loginService.updateAlerts(request).subscribe((data)=>{
                if(data['message'] == 'success'){
                    this.gridApi.updateRowData({ remove: arr });
                }
                else{
                    this.toastService.error('Record not saved: Please review or contact Help Desk','My Alerts');
                }
            },error=>{
                this.toastService.error('Record not saved: Please review or contact Help Desk','My Alerts');
            })
        }
        navigate(){
            if(this.params.data.description === 'New document has been generated'){
                this.router.navigate(['documents'])
            }
            else if(this.params.data.description.indexOf('Good Cause') !== -1 || this.params.data.description.indexOf('Exemption') !== -1 || this.params.data.description.indexOf('Reimbursement') !== -1) {
                this.router.navigate(['requests'])
            }
            else {
                this.router.navigate(['participation'])
            }
        }
        focus(event){
            if(event.keyCode == 9){
              this.gridApi.ensureIndexVisible(this.gridApi.paginationGetCurrentPage()*10);
              let firstCol = this.gridColumnApi.getAllDisplayedColumns()[0];
              this.gridApi.ensureColumnVisible(firstCol);
              if(firstCol.gridOptionsWrapper.gridOptions.rowData.length == 0) {
                return;
              }
              else if((this.gridApi.getFocusedCell().rowIndex >=9) && (this.gridApi.getFocusedCell().rowIndex)% ((this.gridApi.paginationGetCurrentPage()*10)+9) == 0){
                this.gridApi.paginationGoToNextPage();
              }
              else{
                event.preventDefault();
                this.gridApi.setFocusedCell((this.gridApi.getFocusedCell().rowIndex)+1, firstCol);
              }
            }
            else{
              return;
            }
          }

}



// WEBPACK FOOTER //
// ./src/app/acknowledge/acknowledge.component.ts